import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=606bf65f&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606bf65f')) {
      api.createRecord('606bf65f', component.options)
    } else {
      api.reload('606bf65f', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=606bf65f&", function () {
      api.rerender('606bf65f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xGD5lfQhFdZh/JS/comp/ImgFallback.vue"
export default component.exports